import { Skeleton, Stack } from "@mui/material"
import { alpha } from "@mui/material/styles"
import { makeStyles } from "tss-react/mui"

import { HIDDEN_IN_PRINT } from "../../print/printPageOnly"
import { BlockTitle } from "../../dialogs/receiptConfirmOrderDialog/components/common/SectionTitle"
import { OrderChatMessageBubble } from "../OrderChatMessageBubble"
import { useOrderChat } from "../useOrderChat"

const useStyles = makeStyles()((theme) => ({
    page: {
        padding: "3.875rem",
        height: "fit-content",
        backgroundColor: theme.palette.common.white,
        boxShadow: `0 0 .625rem 0 ${alpha(theme.palette.common.black, 0.15)}`,
        "@media print": {
            width: "100%",
            padding: "1.5rem",
            boxShadow: "none",
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            padding: "2rem 1.5rem",
            boxShadow: "none",
        },
    },
    message: {
        "@media print": {
            pageBreakInside: "avoid",
            breakInside: "avoid",
        },
    },
    loadingPage: {
        ...HIDDEN_IN_PRINT,
    },
    messageSkeleton: {
        borderRadius: ".75rem",
    },
}))

type OrderChatHistoryPageProps = Readonly<{
    orderId: number
    className?: string
}>

export function OrderChatHistoryPage({ orderId, className }: OrderChatHistoryPageProps) {
    const { classes, cx } = useStyles()
    const { messages, isLoading } = useOrderChat(orderId)

    if (isLoading) {
        return (
            <Stack spacing="1rem" className={cx(classes.page, className, classes.loadingPage)}>
                <Skeleton variant="rounded" height="6.5rem" className={classes.messageSkeleton} />
                <Skeleton variant="rounded" height="6.5rem" className={classes.messageSkeleton} />
            </Stack>
        )
    }

    if (!messages.length) {
        return null
    }

    return (
        <Stack spacing="1.5rem" className={cx(classes.page, className)}>
            <BlockTitle translationKey="order-chat-history-print-title">Chat history</BlockTitle>
            <Stack spacing="1rem">
                {messages.map((message) => (
                    <OrderChatMessageBubble key={message.id} message={message} className={classes.message} />
                ))}
            </Stack>
        </Stack>
    )
}
